import { Vue, i18n } from './core'
import checkoutStore from './stores/checkout'

document.addEventListener('DOMContentLoaded', () => {
  const $el = document.getElementById('address-home')

  if ($el) {
    new Vue({
      el: $el,
      i18n,
      data: {
        currentDeliveryAddress: checkoutStore.currentDeliveryAddress()
      },
      mounted () {
        const headerBar = document.getElementById('header-bar')
        headerBar.classList.remove('d-none')
        headerBar.classList.add('d-flex')
      }
    })
  }
})
